import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import { requestResponse } from '../Requests';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme: any) => ({
  logo: { width: 70, marginBottom: '10px', marginTop: '40px' },
  DialogContent: {
    textAlign: 'center',
  },
  DialogContentText: {
    marginTop: theme.spacing(2),
    fontWeight: 'bold',
  },
  topMargin: {
    marginTop: theme.spacing(2),
  },
  button: { fontSize: 'large' },
}));

export default function ShowDateAndChanges({ request, showResponse }) {
  const classes = useStyles();
  const onClick = async () => {
    switch (request.status) {
      case 'approved':
        await showResponse(requestResponse.approvedChangesNoRecalc);
        break;
      case 'pending_customer_approval':
        await showResponse(requestResponse.pendingCustomerApproval);
        break;
      case 'rejected':
        await showResponse(requestResponse.rejected);
        break;
    }
  };

  return (
    <>
      <DialogContent className={classes.DialogContent}>
        <img
          src={'./icons/edit.svg'}
          className={classes.logo}
          alt="edit logo"
        />
        {request.type === 'financing_application' && (
          <>
            <Typography variant="h6" className={classes.DialogContentText}>
              On {moment(request.created_at).format('MM/DD/YYYY')}, you
              requested
              <br /> to change the followings Lines:
            </Typography>
            {request.lineNames?.map((name, id) => {
              return (
                <Typography variant="h6" key={id}>
                  {name}
                </Typography>
              );
            })}
          </>
        )}
        {request.type === 'payment' && (
          <>
            <Typography variant="h6" className={classes.DialogContentText}>
              On {moment(request.created_at).format('MM/DD/YYYY')} you requested
              to <br />
              perform change{'(s)'} to your <br />
              Funds Deliveries:
            </Typography>
            <Typography variant="h6">
              {moment(request.original_start_date).isAfter(
                moment(request.new_start_date),
              )
                ? 'Postpone '
                : 'Move up '}
              a funds delivery from{' '}
              {moment(request.original_start_date).format('MM/DD/YYYY')} <br />
              to {moment(request.new_start_date).format('MM/DD/YYYY')}
            </Typography>
          </>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={onClick}
          className={classes.topMargin + ' ' + classes.button}
        >
          View Response
        </Button>
      </DialogContent>
    </>
  );
}
